import React from "react";
import { merchantCategoriesGlobal } from "../../../../utils/merchCategoriesGlobal";
import "../styles/ProfileActivityLog.css";
import { OvalLoader } from "../../../Common/Loaders";

const ProfileActivityLog = ({ activityData, isLoading, isError, error }) => {
  if (isLoading) {
    return (
      <div className="profile-activity-section">
        {/* <h3 className="profile-activity-title">Activity Log</h3> */}
        <div className="profile-activity-loader">
          <OvalLoader visible={true} color="#3366CC" />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="profile-activity-section">
        {/* <h3 className="profile-activity-title">Activity Log</h3> */}
        <div className="profile-activity-error">
          Error loading activity log: {error?.error || "Unknown error"}
        </div>
      </div>
    );
  }

  if (!activityData || Object.keys(activityData).length === 0) {
    return (
      <div className="profile-activity-section">
        {/* <h3 className="profile-activity-title">Activity Log</h3> */}
        <div className="profile-no-activity">No activity logs yet.</div>
      </div>
    );
  }

  return (
    <div className="profile-activity-section">
      {/* <h3 className="profile-activity-title">Activity Log</h3> */}
      <div className="profile-activity-logs">
        {Object.keys(activityData).map((date, i) => (
          <div key={i} className="profile-activity-date-group">
            <div className="profile-activity-date">{date}</div>
            {activityData[date].map((log, index) => (
              <div key={index} className="profile-activity-entry">
                <div className="profile-activity-time-message">
                  <span className="profile-activity-time">{log.time} :</span>
                  <span
                    className={`profile-activity-message ${getProfileActivityTypeClass(
                      log.activityLogType
                    )}`}
                  >
                    {formatProfileActivityMessage(log)}
                  </span>
                </div>

                {log.activityLogType === "PROFILE_UPDATED" &&
                  log.details?.changeDetails &&
                  Object.keys(log.details.changeDetails).length > 0 && (
                    <div className="profile-activity-changes">
                      <table className="profile-changes-table">
                        <thead>
                          <tr>
                            <th className="field-col">Field</th>
                            <th className="new-value-col">New Value</th>
                            <th className="old-value-col">Previous Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(log.details.changeDetails).map(
                            (field, fieldIndex) => {
                              const change = log.details.changeDetails[field];
                              return (
                                <tr key={fieldIndex}>
                                  <td className="field-col">
                                    {formatFieldName(field)}
                                  </td>
                                  <td className="new-value-col">
                                    {field === "category"
                                      ? renderCategoryBadges(change.newValue)
                                      : field === "projectUrls"
                                      ? `${change.newValue?.length || 0} images`
                                      : change.newValue || "None"}
                                  </td>
                                  <td className="old-value-col">
                                    {field === "category"
                                      ? renderCategoryBadges(
                                          change.previousValue
                                        )
                                      : field === "projectUrls"
                                      ? `${
                                          change.previousValue?.length || 0
                                        } images`
                                      : change.previousValue || "None"}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                {log.activityLogType === "MERCH_PROFILE_DECLINED" &&
                  log.details?.reason && (
                    <div className="profile-decline-reason">
                      <strong>Reason:</strong> {log.details.reason}
                    </div>
                  )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const formatProfileActivityMessage = log => {
  switch (log.activityLogType) {
    case "PROFILE_UPDATED":
      const changedFields = log.details?.changeDetails
        ? Object.keys(log.details.changeDetails).length
        : 0;
      return `Merchant updated profile${
        changedFields > 0
          ? ` (${changedFields} field${changedFields > 1 ? "s" : ""} changed)`
          : ""
      }`;

    case "MERCH_PROFILE_DECLINED":
      return "Admin declined the profile";

    case "PROFILE_UNDER_REVIEW":
      return "Merchant submitted profile for review";

    default:
      return log.message || `Activity: ${log.activityLogType}`;
  }
};

const formatFieldName = field => {
  // Convert camelCase or snake_case to Title Case with spaces
  return field
    .replace(/([A-Z])/g, " $1") // Insert a space before all capital letters
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/^\w/, c => c.toUpperCase()); // Capitalize the first letter
};

const getProfileActivityTypeClass = activityType => {
  switch (activityType) {
    case "PROFILE_UPDATED":
      return "profile-activity-update";
    case "MERCH_PROFILE_DECLINED":
      return "profile-activity-decline";
    case "PROFILE_UNDER_REVIEW":
      return "profile-activity-review";
    default:
      return "";
  }
};

const renderCategoryBadges = categoryIds => {
  if (!categoryIds || categoryIds.length === 0) {
    return "None";
  }

  const ENV =
    process.env.REACT_APP_APP_CONFIG !== "production" ? "DEV" : "PROD";

  return (
    <div className="profile-category-badges">
      {categoryIds.map((categoryId, index) => {
        const categoryInfo = merchantCategoriesGlobal[ENV][categoryId];
        return (
          <span key={index} className="profile-category-badge">
            {categoryInfo?.name || "Unknown"}
          </span>
        );
      })}
    </div>
  );
};

export default ProfileActivityLog;
